// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   FaRegCalendarAlt,
//   FaRegClock,
//   FaRegFileAlt,
//   FaRegUser,
//   FaPaw,
//   FaStethoscope,
// } from "react-icons/fa";
// import { FiTrash2 } from "react-icons/fi";
// import { MdOutlineArrowBackIos } from "react-icons/md";

// import {
//   fetchConsultationById,
//   deleteConsultation,
//   clearDetail,
// } from "../../redux/slices/consultationSlice";
// import DeleteModal from "../../components/common/DeleteModal";

// export default function AppointmentInfo() {
//   const { id } = useParams();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [modalOpen, setModalOpen] = useState(false);

//   /* ---------- Redux state ---------- */
//   const { detail: appointment, detailStatus, error } = useSelector(
//     (s) => s.consultations
//   );

//   /* ---------- Effects ---------- */
//   useEffect(() => {
//     if (id) dispatch(fetchConsultationById(id));

//     return () => {
//       dispatch(clearDetail());
//     };
//   }, [dispatch, id]);

//   /* ---------- Early states ---------- */
//   if (detailStatus === "loading")
//     return <div className="px-20 pt-10">Loading …</div>;
//   if (detailStatus === "failed")
//     return <div className="px-20 pt-10">Failed to load appointment. {error}</div>;
//   if (!appointment)
//     return <div className="px-20 pt-10">Appointment not found.</div>;

//   /* ---------- Data helpers ---------- */
//   const {
//     petParent,
//     pet,
//     petType,
//     veterinarian,
//     datetime,
//     type,
//     channel,
//     status, // optional
//   } = appointment;

//   const statusColors = {
//     Upcoming: "bg-[#FEF7E7] text-[#FFA726]",
//     Completed: "bg-green-100 text-green-800",
//     Cancelled: "bg-red-100 text-red-800",
//     Default: "bg-gray-100 text-gray-600",
//   };


// // Split into date and time
// const [datePart, timePart] = datetime.split(" "); 
// // But we need "2025-01-15" as date and "10:00 AM (30mins)" as time+duration
// const date = datetime.split(" ")[0]; // "2025-01-15"
// const time = datetime.split(" ").slice(1).join(" "); // "10:00 AM (30mins)"

//   /* ---------- Handlers ---------- */
//   const handleDelete = () => {
//     dispatch(deleteConsultation(id));
//     setModalOpen(false);
//     navigate(-1); // go back to previous page
//   };

//   /* ---------- JSX ---------- */
//   return (
//     <div className="relative min-h-screen bg-white font-inter px-6 pt-12">
//       {/* ═══════════════ Top bar ═══════════════ */}
//       <div className="flex justify-between items-start mb-8">
//         <div className="flex items-start">
//           <button
//             onClick={() => navigate(-1)}
//             aria-label="Go Back"
//             className="mt-1 mr-3 p-4 text-2xl text-gray-800 hover:text-blue-600"
//           >
//             <MdOutlineArrowBackIos />
//           </button>

//           <div>
//             <div className="text-2xl font-bold text-black">
//               Appointment Information
//             </div>
//             <div className="text-gray-700 text-base font-normal mt-1">
//               View detailed information and take actions if needed.
//             </div>
//           </div>
//         </div>

//         <button
//           onClick={() => setModalOpen(true)}
//           className="flex items-center gap-2 bg-[#2B80FF] hover:bg-blue-600 text-white font-medium px-6 py-2 rounded-lg text-lg shadow transition-all"
//         >
//           Delete <FiTrash2 className="text-[18px]" />
//         </button>
//       </div>

//       {/* ═══════════════ Content area ═══════════════ */}
//       <div className="flex mt-10 justify-between items-start px-10">
//         {/* ---------- Left column ---------- */}
//         <div className="flex flex-col w-full">
//           <h3 className="text-black text-lg font-semibold mb-4">
//             Appointment Details
//           </h3>

//           {/* Pet avatar + name */}
//           <div className="flex items-center gap-5">
//             <img
//               src={"https://placehold.co/80x80"}
//               alt={pet || "Pet"}
//               className="w-20 h-20 rounded-full object-cover border"
//             />
//             <div>
//               <div className="text-xl font-bold text-black">{pet}</div>
//               <div className="text-gray-700 text-[16px] -mt-0.5">
//                 {petType}
//               </div>
//             </div>

//             {/* Status badge */}
//             {status && (
//               <span
//                 className={`ml-40 px-3 py-2 text-sm font-semibold rounded ${
//                   statusColors[status] || statusColors.Default
//                 }`}
//               >
//                 {status}
//               </span>
//             )}
//           </div>

//         <div className="mt-10 flex flex-col gap-6 w-4/5 ">
//   {/* Left and Right columns */}
//   <div className="flex justify-between gap-10 pl-24 ">
//     {/* Left column */}
//     <div className="flex flex-col gap-4 text-[16px] text-gray-800">
//       <div className="flex items-center gap-2">
//         <FaRegUser className="text-blue-600" />
//         {petParent}
//       </div>
//       <div className="flex items-center gap-2">
//         <FaPaw className="text-blue-600" />
//         {pet} ({petType})
//       </div>
//       <div className="flex items-center gap-2">
//         <FaStethoscope className="text-blue-600" />
//         {veterinarian}
//       </div>
//     </div>

//     {/* Right column */}
//     <div className="flex flex-col gap-4 text-[16px] text-gray-800">
//       <div className="flex items-center gap-2">
//         <FaRegCalendarAlt className="text-blue-600" />
//         <span>{date}</span>
//       </div>
//       <div className="flex items-center gap-2">
//         <FaRegClock className="text-blue-600" />
//         <span>{time}</span>
//       </div>
//       <div className="flex items-center gap-2">
//         <FaRegFileAlt className="text-blue-600" />
//         <span>{type}</span>
//       </div>
//     </div>
//   </div>

//   {/* Session Channel below */}
//   {channel && (
//     <div className="mt-6 pl-24">
//       <h3 className="text-black text-lg font-semibold mb-2">
//         Session Channel
//       </h3>
//       <p className="text-blue-600">{channel}</p>
//     </div>
//   )}
// </div>
// </div>
// </div>


//       {/* ═══════════════ Footer buttons ═══════════════ */}
//       <div className="flex gap-4 mt-28 justify-end">
//         <button
//           onClick={() => navigate(-1)}
//           className="border border-[#2B80FF] text-blue-700 rounded-lg px-8 py-2 text-lg font-medium bg-white hover:bg-blue-50 transition-all"
//         >
//           Cancel
//         </button>
//         <button
//           onClick={() => navigate(`/admin/appointments/${id}/edit`)}
//           className="bg-[#2B80FF] text-white rounded-lg px-8 py-2 text-lg font-medium hover:bg-blue-600 transition-all shadow"
//         >
//           Edit
//         </button>
//       </div>

//       {/* ═══════════════ Delete modal ═══════════════ */}
//       <DeleteModal
//         open={modalOpen}
//         onClose={() => setModalOpen(false)}
//         onDelete={handleDelete}
//         profileType="Appointment"
//       />
//     </div>
//   );
// }


import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import DetailView from "../../components/details/DetailView";
import {
  fetchConsultationById,
  deleteConsultation,
  clearDetail,
} from "../../redux/slices/consultationSlice";

export default function AppointmentInfo() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { detail: appointment, detailStatus, error } = useSelector(
    (s) => s.consultations
  );

  // Fetch appointment by ID
  useEffect(() => {
    if (id) dispatch(fetchConsultationById(id));
    return () => dispatch(clearDetail());
  }, [dispatch, id]);

  if (detailStatus === "loading") return <div className="px-20 pt-10">Loading …</div>;
  if (detailStatus === "failed")
    return <div className="px-20 pt-10">Failed to load appointment. {error}</div>;
  if (!appointment) return <div className="px-20 pt-10">Appointment not found.</div>;

  // Handlers
  const handleDelete = () => {
    dispatch(deleteConsultation(id));
    navigate(-1); // go back after deletion
  };

  const handleEdit = () => {
    navigate(`/swift-app/admin/consultation/${id}/edit`);
  };

  return (
    <DetailView
      title="Appointment Information"
      type="appointment"
      data={appointment}
      onDelete={handleDelete}
      onEdit={handleEdit}
    />
  );
}
